import { render, staticRenderFns } from "./PageHeaderReports.vue?vue&type=template&id=3acdf844&scoped=true&"
import script from "./PageHeaderReports.vue?vue&type=script&lang=js&"
export * from "./PageHeaderReports.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderReports.vue?vue&type=style&index=0&id=3acdf844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acdf844",
  null
  
)

export default component.exports